import axios from "@/libs/api.request";
// 获取批量
export const getFreightRule = params => {
  return axios.request({
    url: "/finance/freightrule",
    method: "GET",
    params
  });
};
// 获取
export const getDetails = id => {
  return axios.request({
    url: `/finance/freightrule/${id}`,
    method: "GET"
  });
};
// 删除
export const del = id => {
  return axios.request({
    url: `/finance/freightrule/${id}`,
    method: "DELETE"
  });
};
// 更新
export const update = data => {
  return axios.request({
    url: `/finance/freightrule/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增
export const add = data => {
  return axios.request({
    url: "/finance/freightrule",
    method: "POST",
    data
  });
};

export const getCheckFreight = params => {
  return axios.request({
    url: "/finance/checkFreightRule",
    method: "GET",
    params
  });
};
